import { action } from "./types";
import { UserManager } from "oidc-client";
import httpClient from "../store/httpClient";

export default {
	[action.BOOTSTRAP]: ({ commit, state }) => {
		return new Promise((resolve, reject) => {
			console.log("start bootstrap application");
			// Einmaliger Storage-Wipe beim Umstieg auf den Authorization Code Flow.
			// Alte Implicit-Flow-Sessions haben keinen Refresh-Token; ihr automatischer
			// Silent-Renew läuft über den iframe/authorize-Weg und scheitert am jetzt
			// code-only Identityserver (unsupported_response_type). Darum beim ersten
			// Laden dieser Version alle oidc-Einträge einmalig entfernen, sodass jeder
			// Client sauber neu im Code Flow anmeldet (und einen Refresh-Token bekommt).
			const AUTH_MIGRATION = "codeflow-v1";
			if (window.localStorage.getItem("authMigration") !== AUTH_MIGRATION) {
				Object.keys(window.localStorage)
					.filter((k) => k.startsWith("oidc."))
					.forEach((k) => window.localStorage.removeItem(k));
				window.localStorage.setItem("authMigration", AUTH_MIGRATION);
			}
			var client = new UserManager(state.oidc.config);
			// Add event when token expires. This is just for monitoring
			// at the beginning. Can be removed later.
			client.events.addAccessTokenExpiring(function () {
				console.log("fertiger token expiring...");
			});
			commit("storeOidcInstance", client);
			console.log("checking user authentication");
			state.oidc.instance
				.getUser()
				.then((user) => {
					if (user === null || user.expired) {
						console.log("user is not authenticated - redirect to signin");
						// Store the actually requested url so we can redirect
						// after authentication to this page.
						window.sessionStorage.setItem("returnUrl", window.location.href);
						state.oidc.instance.signinRedirect();
					} else {
						console.log("user authenticated");
						commit("storeOidcUser", user);
						resolve();
					}
				})
				.catch((err) => {
					// Ein alter/inkompatibler gespeicherter Token (z.B. von vor einem
					// Identityserver-Wechsel) lässt getUser() fehlschlagen. Ohne diesen
					// catch bleibt die Seite dauerhaft weiss, weil das Promise nie
					// aufgelöst wird. Gespeicherten Token löschen und neu anmelden.
					console.log(
						"stored token is invalid, clearing it and redirecting to signin",
						err
					);
					state.oidc.instance.removeUser().finally(() => {
						window.sessionStorage.setItem("returnUrl", window.location.href);
						state.oidc.instance.signinRedirect();
					});
				});
		});
	},
	[action.LOGOUT]: ({ state }) => {
		console.log("redirecting user to signout");
		window.sessionStorage.removeItem("access_token");
		state.oidc.instance.signoutRedirect();
	},
	[action.GetCadToken]: async ({ state }, articleId) => {
		try {
			const response = await httpClient().get(
				`api/Artikel/GetArticleToken?blexonArtikelId=${articleId}`
			);
			return response.data.token;
		} catch (err) {
			console.error(err);
		}
	},
	getBeanstandungCount: async ({ commit }, fertigerId) => {
		try {
			const response = await httpClient().get(
				"api/Ticket/GetNumberOfOpenTicketsForFertiger?fertigerId=" + fertigerId
			);
			commit("beanstandungsCount", response.data);
			commit("beanstandungLoadedForFertigerId", fertigerId);
		} catch (err) {
			console.log(err);
		}
	},
};
